import { foundations } from './chunk-VYR6F67Y.mjs';
import { components } from './chunk-SPKLG64B.mjs';
import { semanticTokens } from './chunk-BF6JLLXF.mjs';
import { styles } from './chunk-VHIIIDDT.mjs';

// src/index.ts
var direction = "ltr";
var config = {
  useSystemColorMode: false,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
};
var theme = {
  semanticTokens,
  direction,
  ...foundations,
  components,
  styles,
  config
};

export { theme };
